import { formatearFecha } from 'src/app/compartido/utilidades/valores.utils';
import { NotificacionDTO, TipoNotificacion } from './header.models';

/* Notificación */
export class Notificacion {
  constructor(
    public id: number,
    public tipo: TipoNotificacion,
    public mensaje: string,
    public url: string | null,
    public leida: boolean,
    public fechaCreacion: string,
  ) {}

  /**
   * Crea un objeto Notificación a partir de los datos del API.
   * @param {NotificacionDTO} notificacion - La notificación como llega del API.
   * @returns {Orden} - El objeto Notificación creado.
   * @author Juan Corral
   */
  public static fromDTO(orden: NotificacionDTO): Notificacion {
    return new Notificacion(
      orden.id,
      orden.tipo,
      orden.mensaje,
      orden.url,
      orden.leida,
      formatearFecha(orden.fecha_creacion, 'ddd, MMM D \n HH:mm'),
    );
  }
}
